module.exports = __webpack_public_path__ + "static/media/table_ref.fbe576cb.png";